import { Transaction } from '@kr/models';

export interface MassPayOut {
  massPayOut: Transaction[];
  totalFee: string;
  totalAmount: string;
  balanceAvailable: string;
  networkBalance: string;
  ourEstimatedFee?: string;
}

export enum PayOutsType {
  SAFE = 'safe',
  RISK = 'risk',
}

export interface MassPayOutEstimates {
  massPayOut: Transaction[];
  totalFee: string;
  totalAmount: string;
  balanceAvailable: string;
  networkBalance: string;
  ourEstimatedFee?: string;
}

export interface PayOutsFilters {
  score: PayOutsType[];
}
